import * as mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

import list from '@/store/shared/selectableList'
import search from '@/store/shared/search'
import forms from './forms'

export default {
  namespaced: true,
  state () {
    return {
      delegations: [],
      availableDelegations: [],
      name: undefined,
      email: undefined,
      delegation: undefined,
      language: undefined,
      loaded: false
    }
  },
  actions,
  getters,
  mutations,
  modules: {
    list,
    search,
    billToCharge: forms,
    autoBillToCharge: forms,
    billToPay: forms,
    autoBillToPay: forms
  }
}
